import React from 'react';

const AlertBox = ({ message, type = "error" }) => {
  if (!message) return null;

  const alertClass = type === "error" ? "bg-red-200 border-red-400 text-red-600" : "bg-green-400 ";

  return (
    <div role="alert" className={` p-3 rounded-lg ${alertClass}`}>
      <span>{type === "error" ? "Error! " : "Success! "}{message}</span>
    </div>
  );
};

export default AlertBox;
